import FormInput from '@form/FormInput';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputErrorMessage } from '../../Form/InputErrorMessage';

interface Props {
    name: string;
}

const RebookingSlotsFieldArray: FC<Props> = ({ name }) => {
    const { control } = useFormContext();
    const { t } = useTranslation('space-manager');
    const { fields, append, remove } = useFieldArray({ control, name });

    return (
        <div className="tw-my-4 tw-flex tw-flex-col tw-gap-3">
            {fields.map((field, index) => (
                <div key={field.id} className="tw-card-bordered tw-flex tw-flex-col tw-gap-3">
                    <div className="tw-grid tw-grid-cols-1 tw-gap-3 md:tw-grid-cols-[1fr_auto]">
                        <FormInput.DatePicker
                            className="!tw-my-0"
                            name={`${name}.${index}.date`}
                            label={t('allocationList.rebookingLink.slots.dateLabel', { number: index + 1 })}
                        />
                        <Button
                            type="button"
                            color="error"
                            className="tw-mb-1 tw-mt-auto"
                            icon={<FontAwesomeIcon icon={faTrash} />}
                            onPress={() => remove(index)}
                        >
                            {t('allocationList.rebookingLink.slots.remove')}
                        </Button>
                    </div>
                    <div className="tw-grid tw-grid-cols-1 tw-gap-3 md:tw-grid-cols-2">
                        <FormInput
                            type="time"
                            name={`${name}.${index}.start_time`}
                            label={t('allocationList.rebookingLink.slots.startTimeLabel')}
                            helperText={t('allocationList.rebookingLink.slots.startTimeHelper')}
                        />
                        <FormInput
                            type="time"
                            name={`${name}.${index}.end_time`}
                            label={t('allocationList.rebookingLink.slots.endTimeLabel')}
                            helperText={t('allocationList.rebookingLink.slots.endTimeHelper')}
                        />
                    </div>
                </div>
            ))}
            <Button
                type="button"
                className="tw-mt-1"
                size="xs"
                block
                icon={<FontAwesomeIcon icon={faPlus} />}
                onPress={() => append({ date: null, start_time: '', end_time: '' })}
            >
                {t('allocationList.rebookingLink.slots.add')}
            </Button>
            <InputErrorMessage name={name} />
        </div>
    );
};

export default RebookingSlotsFieldArray;
